import React from 'react';

class AnimatedLogo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      color: 49
    };
  }

  componentDidMount() {
    this.canvas = document.querySelector('#login-anim-logo');

    if (this.canvas !== null) {
      this.ctx = this.canvas.getContext('2d');
      this.WIDTH = this.canvas.width;
      this.HEIGHT = this.canvas.height;
    }
    this.image = new Image();
    this.image = document.querySelector('#logo-image');

    this.interval = setInterval(
      () => this.setState({color: this.state.color + 1}, this.draw),
      10
    );
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  draw() {
    this.ctx.fillStyle = 'hsl('+ this.state.color +', 50%, 50%)';
    this.ctx.fillRect(0, 0, this.WIDTH, this.HEIGHT);
    this.ctx.drawImage(this.image, 0, 0, this.WIDTH, this.HEIGHT);
  }

  render = () => (
    <div>
      <img hidden id="logo-image" src="/images/logo-mask.png" />
      <canvas id="login-anim-logo" style={{width: '152px', height: '91px'}} />
    </div>
  )
}

export default AnimatedLogo;
